import React from 'react';
import { Grid, Typography } from '@mui/material';
import {
    BlastTadaImg,
    BlastThinkingImg,
    BlastWavingImg,
    BlastWorriedImg,
} from '../../assets';
import { useBlastAI } from '../../core';
import { CHATBOT, blastMainStyles } from './ask-blast-helper';
import { BlastAIChat } from './components/BlastAIChat';

export const AskBlast = (): React.JSX.Element => {
    const { status } = useBlastAI();

    const getBlastImageStatus = (): string => {
        switch (status) {
            case 'error':
                return BlastWorriedImg;
            case 'success':
                return BlastTadaImg;
            case 'loading':
                return BlastThinkingImg;
            default:
                return BlastWavingImg;
        }
    };

    return (
        <Grid sx={blastMainStyles.pageContainer}>
            <Grid sx={blastMainStyles.titleAndAddButtonContainer}>
                <Grid sx={blastMainStyles.titleContainer}>
                    <Typography sx={blastMainStyles.headingText}>
                        {CHATBOT.PAGE_TITLE}
                    </Typography>
                </Grid>
            </Grid>
            <Grid sx={blastMainStyles.bodyContainer}>
                <Grid sx={blastMainStyles.imageContainer}>
                    <img src={getBlastImageStatus()} alt='blast-waving' />
                </Grid>
                <BlastAIChat />
            </Grid>
        </Grid>
    );
};
